import { render } from "./GoogleLoginNew.vue?vue&type=template&id=13a35451&scoped=true&ts=true"
import script from "./GoogleLoginNew.vue?vue&type=script&lang=ts"
export * from "./GoogleLoginNew.vue?vue&type=script&lang=ts"

import "./GoogleLoginNew.vue?vue&type=style&index=0&id=13a35451&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a35451"]])

export default __exports__